import { Container, Box, Grid } from '@material-ui/core'
import { NewHero } from './NewHero'
import { NewNews } from './NewNews'
import { NewProfileWanted } from './NewProfileWanted'
import { NewGoodKnow } from './NewGoodKnow'
import { FetchedMain } from './Fetchedmain'
import { HomeFiltering } from './Filtering'
import { Fragment } from 'react'

export const AccueilEntreprise = (initialData) => {
  return (
    <Fragment>
      <Container maxWidth="md">
        <Box mt={4}>
          <NewHero />
        </Box>
      </Container>
      <Container>
        <Box mt={4}>
          <HomeFiltering />
        </Box>

        <Box mt={8}>
          <FetchedMain initialData={initialData} source="homepage" />
        </Box>

        <Box mt={8}>
          <NewNews countryCode={initialData.isLocal} />
        </Box>

        <Box mt={8}>
          <Grid container spacing={8}>
            <Grid item xs={12} md={7}>
              <NewProfileWanted />
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Fragment>
  )
}

export default AccueilEntreprise